var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-10-05
 * @brief SEI 랜딩 햄버거 메뉴 컴포넌트
 *
 ********************************************************************/
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { getApiLangState, langState } from "../../../recoil/langState";
import { urlState } from "../../../recoil/menuState";
import { demo, userInfoLoginState, userInfoState } from "../../../recoil/userState";
//utils
import * as CONST from "../../../utils/Const";
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as i18n from "../../../utils/langs/i18nUtils";
import * as USERUTILS from "../../../utils/user/userUtils";
//
import { alertState } from "../../../recoil/assessmentState";
function SideBar(props) {
    // trans, navigate, ref
    const navigate = useNavigate();
    const userInfo = useRecoilValue(userInfoLoginState);
    // recoil
    const [recoilUrlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    // use recoil
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    const apiLang = useRecoilValue(getApiLangState);
    const [recoilserInfo, setRecoilUserInfo] = useRecoilState(userInfoState); // recoil userState
    const resetRecoilUserInfo = useResetRecoilState(userInfoState);
    const setRecoilUrl = useSetRecoilState(urlState);
    const [demos, setDemo] = useRecoilState(demo);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { DashBoradGo, urlList, LandingGo, navOpen, t, NavOpen, userId, userPw } = props; // header에서 tag size로 모바일 여부를 체크함
    // test demo login
    function demoLogin(e) {
        let url = CONST.URL_MONITORING;
        //
        if (!userInfo.loginInfo.token) {
            Login(url);
        }
        else {
            // 있으면 로그아웃
            Logout(url);
        }
    }
    function Logout(url) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "POST",
                appPath: `/auth/logout?userId=${userInfo.userId}`,
                appQuery: {
                    userId: userInfo.userId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    sessionStorage.removeItem(CONST.STR_TOKEN);
                    sessionStorage.removeItem(CONST.STR_TOKEN_EXPIRETIME);
                    localStorage.removeItem(CONST.STR_KEEP_LOGIN_YN);
                    localStorage.removeItem(CONST.STR_USERID);
                    localStorage.removeItem(CONST.STR_USERROLE);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN_EXPIRETIME);
                    localStorage.removeItem("demo");
                    resetRecoilUserInfo();
                    Login(url);
                    OpenPop(url);
                }
                else {
                }
            }
        });
    }
    function Login(url) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "POST",
                appPath: `/auth/login`,
                appQuery: {
                    userId: userId,
                    password: userPw,
                    language: apiLang,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    // sessionStorage
                    sessionStorage.setItem(CONST.STR_TOKEN, data.body.token);
                    sessionStorage.setItem(CONST.STR_TOKEN_EXPIRETIME, data.body.tokenExpireTime);
                    // localStorage
                    localStorage.setItem(CONST.STR_USERID, userId);
                    localStorage.setItem(CONST.STR_USERROLE, data.body.role);
                    localStorage.setItem(CONST.STR_REFRESHTOKEN, data.body.refreshToken);
                    localStorage.setItem(CONST.STR_REFRESHTOKEN_EXPIRETIME, data.body.refreshTokenExprieTime);
                    localStorage.setItem("demo", "demo");
                    const detailUserInfo = yield USERUTILS.getDetailUserInfoR(data.body);
                    const lang = CUTIL.frontLangSet(detailUserInfo.language);
                    yield i18n.changeLang(lang);
                    setRecoilLangs(lang);
                    setRecoilUserInfo({
                        loginTime: detailUserInfo.loginTime,
                        userId: detailUserInfo.userId,
                        email: detailUserInfo.email,
                        userName: detailUserInfo.userName,
                        phoneNumber: detailUserInfo.phoneNumber,
                        companyName: detailUserInfo.companyName,
                        zoneName: detailUserInfo.zoneName,
                        department: detailUserInfo.department,
                        role: detailUserInfo.role,
                        language: detailUserInfo.language,
                        classificationCode: detailUserInfo.classificationCode,
                        classification: detailUserInfo.classification,
                        agreeMailReceipt: detailUserInfo.agreeMailReceipt,
                        agreeTos: detailUserInfo.agreeTos,
                        agreePersonalInfo: detailUserInfo.agreePersonalInfo,
                        agreeData: detailUserInfo.agreeData,
                        userIdPk: detailUserInfo.userIdPk,
                        isAutomatedNickName: detailUserInfo.isAutomatedNickName,
                        nickName: detailUserInfo.nickName,
                        userRank: detailUserInfo.userRank,
                        userImage: detailUserInfo.userImage,
                        loginInfo: data.body,
                    });
                    setDemo(true);
                    setRecoilUrl(url);
                    navigate(url);
                    OpenPop(url);
                    if (!demo) {
                        window.location.reload();
                    }
                }
            }
        });
    }
    function OpenPop(e) {
        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.테스트계정으로자동로그인합니다") }));
        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
    }
    return (_jsx(_Fragment, { children: _jsx("nav", Object.assign({ className: `navbar ${navOpen ? "active" : ""}`, onAbort: (e) => NavOpen(e) }, { children: _jsxs("ul", Object.assign({ className: "navbar__menu" }, { children: [urlList.map((menu, idx) => (_jsx("li", Object.assign({ onClick: (e) => LandingGo(menu.url), className: `${menu.url == recoilUrlInfo ? "active" : ""}` }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: menu.name })) }), "landigWebUrl_" + idx.toString()))), _jsxs("li", { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-darkgray js-open", "data-pop": userInfo.companyName == null ? "pop-cmmConfirm1" : "pop1", onClick: (e) => DashBoradGo(e) }, { children: _jsx("span", Object.assign({ className: "icon-go" }, { children: t("메뉴.대쉬보드") })) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic mt-8 ml-0", onClick: (e) => demoLogin(e) }, { children: _jsx("span", Object.assign({ className: "icon-go" }, { children: t("라벨.SEI대시보드체험해보기") })) }))] })] })) })) }));
}
export default SideBar;
